export default "__VITE_ASSET__BqMwkbTt__"